import React, {useState} from 'react';
import styled from "styled-components";
import dayjs from "dayjs";
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import IconBtn from "../IconBtn";
import {colors} from "../../maps/colors";


const WrapperStyled = styled.div`

`;

const ItemStyled = styled.div`
    display: grid;
    grid-template-columns: 70px 110px 120px auto 150px 30px;
    border-bottom: 1px solid rgb(224, 224, 224);
    margin-bottom: 10px;
    padding: 10px;
    align-items: baseline;
`;

const ItemDataStyled = styled.div`

    .active-set {
        cursor: pointer;
        color: ${colors.ORANGE_LIGHT};
    }

    .active {
        color: ${colors.LIME};
    }
`;

const ActionsStyled = styled.div`
    margin-bottom: 20px;
`;

const ListOfFirmwares = ({firmwareData, sensorModels, handleFirmwareDelete, handleActiveFirmware}) => {
    const [filter, s_filter] = useState("");
    const deleteFirmware = (id) => {
        handleFirmwareDelete(id);
    };

    const setActiveFirmware = (id) => {
        handleActiveFirmware(id);
    };

    return (
        <WrapperStyled>
            <ActionsStyled>
                <FormControl style={{marginBottom: 10, width: 220}}>
                    <InputLabel id="demo-simple-select-label">Filter</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={filter}
                        label="Filter"
                        onChange={e => {
                            if (e.target.value === 'all') {
                                s_filter("");
                            } else {
                                s_filter(e.target.value);
                            }
                        }}>
                        <MenuItem value={"all"}>{"All"}</MenuItem>
                        {sensorModels.map(ss => {
                            return (
                                <MenuItem key={ss._id} value={ss._id}>{ss.name}</MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </ActionsStyled>
            {firmwareData?.map((item, idx) => {
                const sensorModel = sensorModels.find(opi => opi._id === item.modelTypeId);

                if (!sensorModel) {
                    return null;
                }
                if (filter) {
                    if (item?.modelTypeId !== filter) {
                        return null;
                    }
                }
                return (
                    <ItemStyled key={item._id + idx}>
                        <ItemDataStyled>
                            {item.version}
                        </ItemDataStyled>
                        <ItemDataStyled>
                            {sensorModel.name}
                        </ItemDataStyled>
                        <ItemDataStyled>
                            {item.isActive && (
                                <span className="active">ACTIVE</span>
                            )}
                            {!item.isActive && (
                                <span
                                    onClick={() => {
                                        setActiveFirmware(item._id);
                                    }}
                                    className="active-set">set ACTIVE</span>
                            )}
                        </ItemDataStyled>
                        <ItemDataStyled>
                            {item.fileName}
                        </ItemDataStyled>
                        <ItemDataStyled>
                            {dayjs(item.createdAt).format("H:mm, M YYYY")}
                        </ItemDataStyled>

                        <ItemDataStyled>
                            <IconBtn
                                onClick={() => {
                                    deleteFirmware(item._id);
                                }}
                                customtheme="normal" size="small" style={{marginLeft: 5}}>delete</IconBtn>
                        </ItemDataStyled>
                    </ItemStyled>
                );
            })}
        </WrapperStyled>
    );
};

export default ListOfFirmwares;